import { CardBody, Table } from "reactstrap";
import { H3, H6, Image, LI, P, UL } from "../../../../../AbstractElements";
import SvgIcon from "../../../../CommonComponents/SvgIcon/SvgIcon";
import { JobTodayHeaderData, JobTodayTableData } from "../../../../../Data/General/Dashboard/Default";
import { dynamicImage } from "../../../../../Utils";

export const JobTodayCardBody = () => {
  return (
    <CardBody>
      <UL className="d-flex align-center justify-content-center gap-3 simple-list flex-row">
        {JobTodayHeaderData.map((item, index) => (
          <LI key={index}>
            <div className="d-flex gap-2">
              <div className={`flex-shrink-0 bg-light-${item.color}`}>
                <SvgIcon className="stroke-icon" iconId={item.svg} />
              </div>
              <div className="flex-grow-1">
                <H3>{item.number}</H3>
                <P>{item.title}</P>
              </div>
            </div>
          </LI>
        ))}
      </UL>
      <div className="table-responsive custom-scrollbar mt-4">
        <Table className="display">
          <thead>
            <tr>
              <th>Time </th>
              <th>Job </th>
              <th>Company</th>
              <th className="text-center">Employee </th>
            </tr>
          </thead>
          <tbody>
            {JobTodayTableData.map((item, index) => (
              <tr key={index}>
                <td>{item.time}</td>
                <td>{item.job}</td>
                <td>{item.company}</td>
                <td>
                  <div className="d-flex align-items-center gap-2">
                    <div className="flex-shrink-0"><Image src={dynamicImage(item.image)} alt="" /></div>
                    <div className="flex-grow-1"><H6>{item.name}</H6></div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </CardBody>
  );
};
